const translations = {
    VISIT: {
        description: 'Visit button',
        primaryValue: 'Visit',
        stringKey: 'portlet_card_visit',
    },
};

module.exports = translations;
